import React from 'react';
import {Link} from 'react-router-dom';
import { injectIntl } from 'react-intl';
import {messages} from  '../common/Translations';

const UsersListDivRow = ({user, companyOptions, roles, onCompanyChange, onIsWebmasterChange, onDelete, intl}) => {

    return (
        <div key={user.id}>
            <div className="row">
                <div className="col-xs-12 col-sm-8">
                    <div className="col-12">#{user.id}</div>
                    <div className="col-12"><strong>{intl.formatMessage(messages.name)}:</strong></div>
                    <div className="col-12">{user.name}</div>
                    <div className="col-12"><strong>{intl.formatMessage(messages.email)}:</strong></div>
                    <div className="col-12">{user.email}</div>
                    <div className="col-12"><strong>{intl.formatMessage(messages.title)}:</strong></div>
                    <div className="col-12">{user.workingTitle}</div>
                    <div className="col-12"><strong>{intl.formatMessage(messages.company)}:</strong></div>
                    <div className="col-12">

                        <select
                        className="form-control clickable"
                        data-user-id={user.id}
                        defaultValue={(user.company) ? user.company.id : null}
                        onChange={onCompanyChange}
                    >
                        {companyOptions}
                    </select>
                     {(user.wasInCompanyName) ? <span className='text-success m-l-15'>Var i {user.wasInCompanyName}</span> : ''}
                    </div>
                    <div className="col-12"><strong>{intl.formatMessage(messages.webmaster)}:</strong></div>
                    <div className="col-12 text-center">
                        <label className="custom-control custom-checkbox">
                            <checkbox>

                            </checkbox>
                            <input
                                type="checkbox"
                                className="custom-control-input"
                                defaultChecked={(user.roles.indexOf(roles.FBG_WEBMASTER) !== -1)}
                                data-user-id={user.id}
                                onChange={onIsWebmasterChange}
                            />
                            <span className="custom-control-indicator"></span>
                        </label>
                    </div>
                </div>
                <div className="col-sx-12 col-sm-4 text-right">
                    <div className="col-12">
                        <div className="btn-group text-right mt-1">
                            <Link to={"/brugere/redigere/"+user.id} className="btn btn-secondary waves-effect list-action">
                                <i className="fa fa-pencil"></i> {intl.formatMessage(messages.listDropDownButtonEdit)}
                            </Link>
                            <button type="button" className="btn clickable btn-secondary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span className="sr-only">{intl.formatMessage(messages.actions)}</span>
                            </button>
                            <div className="dropdown-menu">
                                <button
                                    type="button"
                                    className="dropdown-item clickable"
                                    onClick={() => onDelete(user.id)}
                                >
                                    <i className="fa fa-trash-o"></i> {intl.formatMessage(messages.listDropDownButtonDelete)}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <hr />
        </div>
    );
};

export default injectIntl(UsersListDivRow);



// WEBPACK FOOTER //
// ./web/src/components/users/UsersListDivRow.jsx